import { useAuthStore } from '@stores/auth-store';
import { apiRefreshAccessToken } from '@api/v1/requests';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export const refreshAccessToken = async (failedRequest: any) => {
  try {
    const authStore = useAuthStore();
    if (!authStore.refresh) {
      return Promise.reject(new Error('Refresh token not found.'));
    }

    const payload = {
      refresh: authStore.refresh,
    };
    const res = await apiRefreshAccessToken({ payload });
    await authStore.setAccessToken(res.data);
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};
